import "./SingleSiteTemplate.module.css"
import MainNavigation from "@/reusable_sections/Header"
import SingleSiteTemplateSection from "./sections/SingleSiteTemplateSection"
import BrandFooter from "@/reusable_sections/Footer"

export default function SingleSiteTemplatePage() {

  return (
    <div>
      <MainNavigation />
      <SingleSiteTemplateSection />
      <BrandFooter />
    </div>
  )
}
